import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import Disclosure from "./pages/Disclosure";
import { MiniLandingPage } from "./components/MiniLandingPage";
import { LANDINGS } from "./lib/landings";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
};

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/disclosure" element={<Disclosure />} />
                {LANDINGS.map((l) => (
                    <Route
                        key={l.slug}
                        path={l.slug}
                        element={<MiniLandingPage config={l} />}
                    />
                ))}
            </Routes>
        </BrowserRouter>
    );
}

export default App;
